import React from "react";
import { TextField } from "react-md";

const ReactMDTextField = ({
  meta: { touched, error, warning },
  input,
  ...passThroughProps
}) => (
  <TextField
    errorText={error || warning}
    error={touched && (!!error || !!warning)}
    {...input}
    {...passThroughProps}
  />
);

ReactMDTextField.propTypes = {};
ReactMDTextField.defaultProps = {};

export default ReactMDTextField;



// WEBPACK FOOTER //
// ./src/common/components/ReactMDTextField.jsx